// frontend-web/src/pages/Admin/EditPracticeSet.jsx
import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate, useParams } from "react-router-dom";

export default function EditPracticeSet() {
  const [practiceSet, setPracticeSet] = useState(null);
  const [form, setForm] = useState({ name: "", duration_minutes: 0, num_questions: 0 });
  const [questions, setQuestions] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    loadPracticeSet();
  }, [id]);

  const loadPracticeSet = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/admin/practice_set/${id}`);
      const ps = res.data;
      setPracticeSet(ps);
      setForm({
        name: ps.name,
        duration_minutes: ps.duration_minutes,
        num_questions: ps.num_questions,
      });
      setSelected(ps.questions.map(q => q.id));

      const qRes = await api.get(`/admin/questions?class_id=${ps.class_id}&subject_id=${ps.subject_id}`);
      setQuestions(qRes.data.questions || []);
    } catch (err) {
      alert("Failed to load Practice Set");
      nav("/admin/practice-set-list");
    } finally {
      setLoading(false);
    }
  };

  const toggleQuestion = (qid) => {
    setSelected(prev =>
      prev.includes(qid) ? prev.filter(id => id !== qid) : [...prev, qid]
    );
  };

  const handleSubmit = async () => {
    if (selected.length !== form.num_questions) {
      alert(`Please select exactly ${form.num_questions} questions. Currently selected: ${selected.length}`);
      return;
    }
    try {
      await api.put(`/admin/practice_set/${id}`, {
        name: form.name.trim(),
        duration_minutes: Number(form.duration_minutes),
        num_questions: Number(form.num_questions),
        question_ids: selected
      });
      alert("Practice Set updated successfully!");
      nav("/admin/practice-set-list");
    } catch (err) {
      alert(err.response?.data?.error || "Update failed");
    }
  };

  if (loading) {
    return (
      <div style={{ padding: 60, textAlign: "center", fontSize: 20 }}>
        Loading Practice Set...
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc", fontFamily: "Inter, sans-serif" }}>
      {/* Header */}
      <div style={{ padding: "20px 40px", background: "white", borderBottom: "1px solid #e2e8f0" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
          <button
            onClick={() => nav("/admin/practice-set-list")}
            style={{ padding: "10px 16px", background: "#e2e8f0", border: "none", borderRadius: 8, cursor: "pointer" }}
          >
            ← Back to List
          </button>
          <h1 style={{ margin: 0, fontSize: 28, fontWeight: 700 }}>
            Edit Practice Set: #{id}
          </h1>
        </div>
      </div>

      <div style={{ padding: 40 }}>
        {/* Info Card */}
        <div style={{ background: "white", padding: 24, borderRadius: 16, boxShadow: "0 4px 20px rgba(0,0,0,0.05)", marginBottom: 30 }}>
          <h2 style={{ margin: "0 0 20px", color: "#1e293b" }}>{practiceSet.name}</h2>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 20 }}>
            <div>
              <label style={labelStyle}>Practice Set Name</label>
              <input
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
                style={inputStyle}
                placeholder="e.g. Physics Chapter 1 Test"
              />
            </div>
            <div>
              <label style={labelStyle}>Number of Questions</label>
              <input
                type="number"
                value={form.num_questions}
                onChange={e => setForm({ ...form, num_questions: Number(e.target.value) || 0 })}
                style={inputStyle}
                min="1"
                max="200"
              />
            </div>
            <div>
              <label style={labelStyle}>Duration (minutes)</label>
              <input
                type="number"
                value={form.duration_minutes}
                onChange={e => setForm({ ...form, duration_minutes: Number(e.target.value) || 0 })}
                style={inputStyle}
                min="1"
                max="300"
              />
            </div>
          </div>
        </div>

        {/* Questions Section */}
        <div style={{ background: "white", borderRadius: 16, boxShadow: "0 10px 30px rgba(0,0,0,0.08)", overflow: "hidden" }}>
          <div style={{ padding: "20px 24px", background: "#1e293b", color: "white" }}>
            <h3 style={{ margin: 0 }}>
              Select Questions 
              <span style={{ marginLeft: 12, fontSize: 15, opacity: 0.9 }}>
                (Selected: {selected.length} / {form.num_questions})
              </span>
            </h3>
          </div>

          {/* Question List – Sirf ye part replace kar do */}
            <div style={{ padding: 24, maxHeight: "60vh", overflowY: "auto" }}>
            {questions.length === 0 ? (
                <p style={{ textAlign: "center", color: "#64748b", padding: 40 }}>
                No questions available for this class & subject
                </p>
            ) : (
                <div style={{ display: "grid", gap: 16 }}>
                {questions.map((q, index) => (
                    <label
                    key={q.id}
                    style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 12,
                        padding: 16,
                        background: selected.includes(q.id) ? "#dbeafe" : "#f8fafc",
                        border: `2px solid ${selected.includes(q.id) ? "#3b82f6" : "#e2e8f0"}`,
                        borderRadius: 12,
                        cursor: "pointer",
                        transition: "all 0.2s"
                    }}
                    >
                    {/* Checkbox */}
                    <input
                        type="checkbox"
                        checked={selected.includes(q.id)}
                        onChange={() => toggleQuestion(q.id)}
                        style={{ marginTop: 4, cursor: "pointer" }}
                    />

                    {/* Question Content */}
                    <div
                        style={{ flex: 1 }}
                        onClick={(e) => e.stopPropagation()} // <-- YE LINE SABSE ZAROORI HAI!
                    >
                        <div style={{ fontWeight: 600, marginBottom: 8, color: "#1e293b" }}>
                        Question {index + 1}
                        </div>
                        <div style={{ color: "#475569", lineHeight: 1.6, marginBottom: 8 }}>
                        {q.text}
                        </div>
                        <div style={{ fontSize: 13, color: "#64748b" }}>
                        Correct Answer: <strong style={{ color: "#166534" }}>{q.correct}</strong>
                        </div>
                    </div>
                    </label>
                ))}
                </div>
            )}
            </div>

          {/* Save Button */}
          <div style={{ padding: "20px 24px", background: "#f8fafc", borderTop: "1px solid #e2e8f0", textAlign: "right" }}>
            <button
              onClick={handleSubmit}
              disabled={selected.length !== form.num_questions}
              style={{
                padding: "14px 32px",
                background: selected.length === form.num_questions ? "#10b981" : "#94a3b8",
                color: "white",
                border: "none",
                borderRadius: 12,
                fontSize: 16,
                fontWeight: 600,
                cursor: selected.length === form.num_questions ? "pointer" : "not-allowed"
              }}
            >
              {selected.length === form.num_questions
                ? "Save Changes"
                : `Select ${form.num_questions - selected.length} more question(s)`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Beautiful Styles
const labelStyle = {
  display: "block",
  marginBottom: 8,
  fontSize: 14,
  fontWeight: 600,
  color: "#374151"
};

const inputStyle = {
  width: "100%",
  padding: "12px 16px",
  borderRadius: 12,
  border: "1px solid #d1d5db",
  fontSize: 15,
  background: "#f9fafb"
};